import React, { ChangeEvent } from 'react';
import { ProductVersion } from 'models';
import { useCart } from 'stores/cartPOSContext';
import { useCartSession } from 'stores/cartSessionContext';
import { formatPrice, getFilePath } from 'utils';
import { logo_with_name } from 'utils/importFile';
import { ButtonCommon, InputCommon, showAlertNotification } from '..';

export const ProductSaleCard: React.FC<{ product: ProductVersion; isSession?: boolean }> = ({
  product,
  isSession = false,
}) => {
  const { addItem, getActiveCart } = useCart();
  const { addItem: addItemSession, getActiveCart: getActiveCartSession } = useCartSession();
  const [quantity, setQuantity] = React.useState(1);
  const activeCart = isSession ? getActiveCartSession() : getActiveCart();
  const defaultUnit = product.baseUnit;

  const handleAddToCart = () => {
    // const existingItem = activeCart?.items.find(
    //   (item) => item.productVersion.id === product.id && item.unit.id === defaultUnit?.id,
    // );
    if (product && defaultUnit) {
      addItem(product, defaultUnit, quantity);
      showAlertNotification({
        type: 'success',
        title: 'Thành công',
        message: `Sản phẩm ${product?.name} ${product?.color || ''} ${product?.dimension || ''} đã được thêm vào giỏ hàng.`,
      });
    }
  };

  const handleAddToCartSession = () => {
    const existingItem =
      activeCart?.items.find((item) => item.productVersion.id === product.id && item.unit.id === defaultUnit?.id) ||
      false;
    if (product && defaultUnit && !existingItem) {
      addItemSession(product, defaultUnit, quantity);
      showAlertNotification({
        type: 'success',
        title: 'Thành công',
        message: `Sản phẩm ${product?.name} ${product?.color || ''} ${product?.dimension || ''} đã được thêm vào danh sách.`,
      });
    }
  };

  const imageUrl = `${product?.productImages?.[0]?.image?.filePath ? `${getFilePath()}/${product?.productImages?.[0]?.image?.filePath}` : logo_with_name}`;

  function decrement(e: React.MouseEvent<HTMLButtonElement>): void {
    // Stop event propagation
    e.stopPropagation();
    setQuantity((prev) => (prev > 1 ? prev - 1 : 1));
  }

  function handleInputChange(event: ChangeEvent<HTMLInputElement>): void {
    // Stop event propagation
    event.stopPropagation();
    const value = Number(event.target.value);
    if (!isNaN(value) && value > 0) {
      setQuantity(value);
    }
  }

  function increment(e: React.MouseEvent<HTMLButtonElement>): void {
    // Stop event propagation
    e.stopPropagation();
    setQuantity((prev) => prev + 1);
  }

  // Prevent click events in the input field from bubbling
  const handleInputClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };
  return (
    <div
      className='w-full h-full p-3 bg-white rounded-lg shadow-[1px_1px_5px_0px_rgba(0,0,0,0.25)] 
                flex flex-col gap-1.5 cursor-pointer hover:shadow-md transition-shadow'
      onClick={isSession ? handleAddToCartSession : handleAddToCart}
    >
      <img className='self-stretch h-36 rounded-lg object-cover' src={imageUrl} alt={product.name || 'Sản phẩm'} />

      <div className='flex-wrap justify-start items-center gap-2.5'>
        <span className="text-black text-base font-bold font-['Inter'] leading-normal">
          {[product?.name, product?.color, product?.dimension, product.sizeSpec]
            .filter((product) => product !== undefined && product !== null && product !== '')
            .join(' - ') || ''}{' '}
        </span>
        <span className="text-black/60 text-xs font-normal font-['Inter'] leading-none">
          - {product.product?.code || ''}
        </span>
      </div>

      <div className='inline-flex justify-start items-start gap-3 w-full'>
        <div className='flex-1 flex justify-start items-center gap-1.5'>
          <div className='text-[var(--primaryColor500)] text-xs font-normal'>
            {formatPrice(Number(product.salePrice))} {product.currencyUnit?.name || 'VNĐ'}/{defaultUnit?.name || 'mét'}
          </div>
        </div>
        <div className='text-black text-xs font-normal'>
          Tồn: {product.product?.quantity || 0} {defaultUnit?.name || 'mét'}
        </div>
      </div>
      <div className='inline-flex justify-start items-start gap-1 w-full'>
        <span className='text-[var(--textBalck56)] text-xs font-normal'> Thương hiệu:</span>
        <span className='text-[var(--primaryColor500)] text-xs font-normal'>{product.brand?.name || '---'}</span>
      </div>
      <div className='inline-flex justify-start items-start gap-1 w-full'>
        <span className='text-[var(--textBalck56)] text-xs font-normal'> Danh mục:</span>
        <div className='text-[var(--primaryColor500)]  text-xs font-normal'>{product.category?.name || '---'}</div>
      </div>
      <div className='flex items-center gap-[12px]'>
        <ButtonCommon
          onClick={decrement}
          className='flex items-center justify-center rounded-[8px]'
          color='outline'
          disabled={quantity <= 0}
          size='xxs'
          style={{ width: '24px', height: '24px' }}
        >
          -
        </ButtonCommon>
        <div className=''>
          <InputCommon
            type='text'
            value={quantity}
            onChange={handleInputChange}
            className='w-full text-center'
            twSize='xxs'
            style={{ width: '49px', height: '24px' }}
            min={1}
            onClick={handleInputClick}
          />
        </div>
        <ButtonCommon
          onClick={increment}
          className='flex items-center justify-center rounded-[8px]'
          color='outline'
          // disabled={quantity >= maxQuantity}
          size='xxs'
          style={{ width: '24px', height: '24px' }}
        >
          +
        </ButtonCommon>
      </div>
    </div>
  );
};
